<template>
	<div>
        <div class="row">
            <div class="col-12 col-md-3">
            <h2>
                {{ $t('form-library-item') }}
            </h2>
            </div>
			<div class="col-12 col-md-9">
            <div class="d-flex flex-wrap justify-content-end align-items-center">
                <!-- Add Field Button -->
                <div v-if="isGroup" class="mr-2 mb-2">
                <button @click="addItem" class="btn btn-secondary">
                    {{ $t('add-field') }}
                </button>
                </div>

                <!-- Collection Toggle  -->
                <div class="mr-2 mb-2">
                <YesNoToggle
                    :label="$t('type')"
                    :srOnly="true"
                    v-model="isGroup"
                    :yesLabel="$t('group')"
                    :noLabel="$t('single')"
                    :noFirst="true"
                    class="d-inline-block my-auto"
                    @input="() => {}"
                />
                </div>

                <!-- Save Button -->
                <div class="mb-2 mr-2">
                <button @click="save" class="btn btn-primary">
                    {{ $t('save') }}
                </button>
                </div>
            </div>
            </div>
		</div>
		<div v-if="saved">
			<div class="alert alert-success mt-8">{{ $t('saved') }}</div>
		</div>
        <template v-if="items.length > 0">
            <div class="form-group">
                <label for="item-title">{{ $t('title') }}</label>
                <input id="item-title" name="itemtitle" class="form-control" v-model="group.title" :placeholder="$t('title')" required>
            </div>

            <div class="form-group">
                <label for="item-notes">{{ $t('notes') }}</label>
                <input id="item-notes" name="itemnotes" class="form-control" v-model="group.notes" :placeholder="$t('notes')" required>
            </div>
        </template>
        <div v-for="(item, index) in items" :key="/*item.json?.id || index*/ item.key" class="mb-4">
            <FieldEditor 
                :editing="item.json" 
                :ref="`fieldeditor-${item.key}`" 
                :permissions="permissions"
                v-if="(item_type == 'field' || item_type == 'fieldgroup') && item.json && typeof item.json === 'object' && !Array.isArray(item.json)"
                :other-fields="allFieldConfigs"
            />
            <OptionsEditor v-if="(item_type == 'selectoptions')" :options="item.json"></OptionsEditor>
            <button
				v-if="group && items.length > 1"
				@click="removeItem(index)"
				class="btn btn-sm btn-outline-danger mt-2 mr-2"
			>
				{{ $t('remove') }}
			</button>
            <!-- <button v-if="group" @click="save()" class="btn btn-sm mt-2 btn-outline-primary">
                {{ $t('save') }}
            </button> -->
        </div>
        
        <div class="d-flex flex-wrap justify-content-end align-items-center">
            <!-- Add Field Button -->
            <div v-if="isGroup" class="mr-2 mb-2">
            <button @click="addItem" class="btn btn-secondary">
                {{ $t('add-field') }}
            </button>
            </div>


            <!-- Save Button -->
            <div class="mb-2 mr-2">
            <button @click="save" class="btn btn-primary">
                {{ $t('save') }}
            </button>
            </div>
        </div>
    </div>
</template>

<script>
import FieldEditor from "src/components/FormEditor/FieldEditor";
import OptionsEditor from "src/components/FormEditor/OptionsEditor";
import YesNoToggle from "src/components/Inputs/YesNoToggle";

export default {
	components: {
		FieldEditor,
		OptionsEditor,
        YesNoToggle
	},
    data: function() {
        return {
        	item_id: null,
        	item_type: null,
        	// item: {
        	// 	json: null
        	// },
        	saved: false,
			permissions: [
				{
					value: 'submitter',
					text: this.$t('submitter')
				},
				{
					value: 'reviewer',
					text: this.$t('reviewer')
				},
				{
					value: 'signer',
					text: this.$t('signer')
				},
				{
					value: 'subject',
					text: this.$t('subject')
				}
			],
            isGroup: false,
            items: [
                { key: 'item_0',json:null }
            ],
            group: {
                title: '',
                notes: ''
            },
        }
    },
    methods: {
       addItem() {
            this.ensureDefaultFieldConfig();
            const newField = this.cloneField(this.defaultFieldConfig || { type: 'text' });
            const normalizedField = this.normaliseField(newField); // 👈 add this
            const itemKey = 'item_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);

            this.items.push({
                key: itemKey,
                json: normalizedField 
            });

            this.$nextTick(() => {
                const fe = this.$refs[`fieldeditor-${itemKey}`]?.[0];
                if (fe?.patchField) {
                    fe.patchField(normalizedField);
                }
            });
        },
		removeItem(index) {
			if (this.items.length > 1) {
                if(this.items.length == 2) this.isGroup = false
				this.items.splice(index, 1);
			}
		},
        getDefaultJson() {
			if (this.item_type === "field" || this.item_type === "fieldgroup") {
				return null;
			} else if (this.item_type === "selectoptions") {
				return [];
			}
			return null;
		},
    	save() {

            let data = {
                title: this.group.title,
                notes: this.group.notes,
                item_id: this.item_id ? this.item_id : null,
                type: this.item_type
            }

            const fields = this.items.map((item) => {
                return {
                    settings: item.json,
                    type: item.json?.type || null,
                    id: item.json?.id || null 
                }
            })

            // Hack to make this compatible with FieldEditor
            if(this.items.length == 1) data = {
                ...data,
                settings: this.items[0].json,
            }
            else data = {
                ...data,
                fields 
            }

  			this.$cfetch(`${this.$settings.APIBaseURL}/formlibrary/save`, {
  				method: 'post',
  				data
  			})
			.then(json => {
				if (json.status == 'SUCCESS') {
					//this.item_id = json.item.id;
					this.saved = true;
					setTimeout(() => {
						this.saved = false;
					}, 5000);
				}
			}).catch(error => {
				this.$log.error.call(this, error);
                console.error(error)
			});
    	},
    	getItem(id) {
  			this.$cfetch(`${this.$settings.APIBaseURL}/formlibrary/getitem/${id}`)
			.then(res => {
				this.$store.commit("hideBlockingSpinner");
				if (res.status == 'SUCCESS') {
					
                    this.group.title = res.item.title;
                    this.group.notes = res.item.notes;

                    if (Array.isArray(res.item.json)) {
                        this.items = [
                            ...res.item.json.map(item => ({ json: this.normaliseField(item) }))
                        ]

                        this.isGroup = true;
                    }
                    else this.items = [{ json: this.normaliseField(res.item.json) }];
                	
					this.item_id = res.item.id;
					this.item_type = res.item.type;

                    this.$nextTick(() => {
                        this.ensureDefaultFieldConfig();
                        
                        this.items.forEach((item, index) => {
                            const feRef = this.$refs[`fieldeditor-${index}`];
                            if (feRef && feRef[0]?.patchField) {
                            feRef[0].patchField(item.json);
                            }
                        });
                    });
				}
			}).catch(error => {
				this.$log.error.call(this, error);
				this.$store.commit("hideBlockingSpinner");
                console.error(error)
			});
    	},
        resetToDefaults() {
            if (this.item_type === 'field' || this.item_type === 'fieldgroup') {
            // Leave json as null — FieldEditor will handle default internally
            this.items = [{ json: null }];
            } else if (this.item_type === 'selectoptions') {
            this.items = [{ json: [] }];
            } else {
            this.items = [{ json: null }];
            }
        },
        ensureDefaultFieldConfig() {
            if (this.defaultFieldConfig) return;

            const firstKey = this.items.length > 0 ? this.items[0].key : 'item_0';

            const feRef = this.$refs[`fieldeditor-${firstKey}`];
            if (feRef && feRef[0]?.getDefaultField) {
            this.defaultFieldConfig = feRef[0].getDefaultField();
            }

            // fallback if somehow still missing
            // if (!this.defaultFieldConfig) {
            // this.defaultFieldConfig = { type: 'text', label: '', permissions: ['submitter'] };
            // }
        },
        
        normaliseField(json) {
            if (!json || typeof json !== 'object') {
                json = {};
            }
            const field = JSON.parse(JSON.stringify(json));

  
            // Ensure other defaults
            if (field.conditional === undefined) field.conditional = null;
            if (field.permission === undefined) field.permission = [];
            if (field.hideifcantcomplete === undefined) field.hideifcantcomplete = false;

            return field;
        },
        cloneField(field) {
            if (field == null || typeof field !== 'object') {
                return field;
            }
            if (Array.isArray(field)) {
                return field.map(item => this.cloneField(item));
            }
            const clone = {};
            for (const key in field) {
                if (Object.prototype.hasOwnProperty.call(field, key)) {
                clone[key] = this.cloneField(field[key]);
                }
            }
            return clone;
        }
    },
    computed: {
       allFieldConfigs() {
            return this.items
            .map(i => i.json)
            .filter(json => json && json.id && json.type !== 'group')
            //.map(json => this.cloneField(json)); // clone to break reference NEVER DO THIS
        }
    },
    mounted() {
        this.item_type = this.$route.query.type || null;

    	if(this.$route.params.itemid) {
    		this.getItem(this.$route.params.itemid)
    	} else {
    		this.items = [];

            this.$nextTick(() => {
                this.ensureDefaultFieldConfig();
                // Update first item 
                if (this.item_type === 'field' || this.item_type === 'fieldgroup') {
                    // this.$set(this.items, 0, {
                    //     ...this.items[0],
                    //     json: JSON.parse(JSON.stringify(this.defaultFieldConfig))
                    // });
                    // Create first item with key
                const itemKey = 'item_0';
                const json = this.defaultFieldConfig 
                    ? this.cloneField(this.defaultFieldConfig)
                    : { type: 'text', id: null, question: null, /* ... */ };

                this.items.push({
                    key: itemKey,
                    json: json
                });

                // ensure it's fully initialized
                this.$nextTick(() => {
                    const fe = this.$refs[`fieldeditor-${itemKey}`]?.[0];
                    if (fe?.patchField) {
                        fe.patchField(json);
                    }
                });
                }
                
                this.$store.commit("hideBlockingSpinner");
            });
    	}
    },
    
    
}
</script>
